import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Home from "./pages/Home";
import Catalog from "./pages/Catalog";
import ProductPage from "./pages/ProductPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import Privacidad from "./pages/Privacidad";
import Terminos from "./pages/Terminos";
import QuoteTracking from "./pages/QuoteTracking";
import TrackingRecovery from "./pages/TrackingRecovery";
import NotFound from "./pages/NotFound";
import Contact from "./components/Contact";
import QuoteForm from "./components/QuoteForm";
import WhatsAppButton from "./components/WhatsAppButton";
import VisitTracker from "./components/VisitTracker";
import { Toaster } from "sonner";
import "./App.css";

// Componente para proteger rutas
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("admin_token");
  
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }
  
  return children;
};

function App() {
  return (
    <HelmetProvider>
    <Router>
      <VisitTracker />
      <Toaster
        position="top-right"
        richColors
        closeButton
        duration={4000}
      />
      <WhatsAppButton />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/productos" element={<Catalog />} />
        <Route path="/productos/:slug" element={<ProductPage />} />
        <Route path="/contacto" element={<Contact standalone />} />
        <Route path="/cotizacion" element={<QuoteForm standalone />} />
        <Route path="/seguimiento" element={<TrackingRecovery />} />
        <Route path="/seguimiento/:token" element={<QuoteTracking />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route 
          path="/admin/dashboard" 
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          } 
        />
        <Route path="/privacidad" element={<Privacidad />} />
        <Route path="/terminos" element={<Terminos />} />
        {/* Ruta catch-all */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
    </HelmetProvider>
  );
}

export default App;